import Vue from 'vue'
import { Modal as Template } from '../4trend/Modal'
import { EVENT_HIDDEN } from '../Bootstrap/Modal'

export const ModalAjax = Vue.extend({
	data: () => ({
		title: '',
		contentUrl: '/test.html',
		buttons: []
	}),
	methods: {
		getData() {
			return fetch(this.contentUrl);
		},
		insertContent(data) {
			data.text().then(html =>
				$(this.$refs.content).html(html)
			);
		}
	},
	mounted() {
		this.getData()
			.then(this.insertContent)
			.then(() =>
				this.$nextTick(() => {
					document.body.appendChild(this.$el);
					this.$refs.modal.show();
				})
			);

		$(this.$el).on(EVENT_HIDDEN, () => this.$destroy());
	},
	destroyed() {
		this.$el.parentElement.removeChild(this.$el);
	},
	render: function(h) {
		return (
			<Template class="ft-modal-ajax" ref="modal" title={ this.title }>
				<div ref="content"></div>
				{ this.buttons }
			</Template>
		)
	}
})
